(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4675],{

/***/ 26908:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/playlist/recently-added",
      function () {
        return __webpack_require__(11965);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 2297:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(84911);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8014);
/* harmony import */ var components_DramoxImage__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(20010);
/* harmony import */ var next_translate_useTranslation__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(62044);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(56168);
/* harmony import */ var _context__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(52662);
/* harmony import */ var _enums_namespaces__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(99731);
/* harmony import */ var _helpers__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(17651);
/* harmony import */ var _typings_api__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(81962);
/* harmony import */ var _AppLink_AppLink__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(3245);
/* harmony import */ var _Select_Select__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(53173);











var SortType;
(function(SortType) {
    SortType["DateDesc"] = "dateAsc";
    SortType["DateAsc"] = "dateDesc";
    SortType["Alpha"] = "alphabeticallyDesc";
})(SortType || (SortType = {}));
var CategorySectionPlaylist = function(param) {
    var headline = param.headline, plays = param.plays, index = param.index, _isSortable = param.isSortable, isSortable = _isSortable === void 0 ? false : _isSortable, _emptyState = param.emptyState, emptyState = _emptyState === void 0 ? false : _emptyState;
    var ref = (0,next_translate_useTranslation__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_enums_namespaces__WEBPACK_IMPORTED_MODULE_5__/* .Namespace.Common */ .l.Common), lang = ref.lang, t = ref.t;
    var user = (0,_context__WEBPACK_IMPORTED_MODULE_4__/* .useAuth */ .aC)().user;
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)([]), sortedPlays = ref1[0], setSortedPlays = ref1[1];
    (0,react__WEBPACK_IMPORTED_MODULE_3__.useEffect)(function() {
        onSortChange(SortType.DateDesc);
    }, []);
    var onSortChange = function(sort) {
        var tempPlays = (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(plays);
        if (sort === SortType.Alpha) {
            tempPlays.sort(function(a, b) {
                return a.title.localeCompare(b.title);
            });
            setSortedPlays(tempPlays);
        } else if (sort === SortType.DateAsc || sort === SortType.DateDesc) {
            tempPlays.sort(function(a, b) {
                var first = new Date(a.watchlist_added);
                var second = new Date(b.watchlist_added);
                if (first.getTime() < second.getTime()) {
                    return sort === SortType.DateAsc ? -1 : 1;
                } else if (first.getTime() > second.getTime()) {
                    return sort === SortType.DateAsc ? 1 : -1;
                } else {
                    return 0;
                }
            });
            setSortedPlays(tempPlays);
        }
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "category-section category-playlist ".concat(!index || index === 0 ? "first" : ""),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "play-list-wrapper ".concat(isSortable ? "with-sort" : ""),
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "sort-wrapper",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                            children: headline
                        }),
                        isSortable ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "sort-option ",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                    children: [
                                        t("sort_from"),
                                        ":"
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Select_Select__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                                    className: "sort-select",
                                    name: "",
                                    onChange: function(val) {
                                        onSortChange(val);
                                    },
                                    options: [
                                        {
                                            value: SortType.DateDesc,
                                            label: "".concat(t("sort_date_desc"))
                                        },
                                        {
                                            value: SortType.DateAsc,
                                            label: "".concat(t("sort_date_asc"))
                                        },
                                        {
                                            value: SortType.Alpha,
                                            label: "".concat(t("sort_alphabetically_desc"))
                                        }, 
                                    ],
                                    defaultValue: SortType.DateDesc
                                })
                            ]
                        }) : null
                    ]
                }),
                (plays === null || plays === void 0 ? void 0 : plays.length) === 0 && emptyState ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "empty-list",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "icon"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                            children: t("add_first_play")
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                            children: t("how_add")
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_AppLink_AppLink__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                            href: _helpers__WEBPACK_IMPORTED_MODULE_6__/* .Permalink.root */ .xm.root(user, lang),
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                children: t("check_library")
                            })
                        })
                    ]
                }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ul", {
                    className: "play-list",
                    children: sortedPlays === null || sortedPlays === void 0 ? void 0 : sortedPlays.map(function(play, i) {
                        var ref;
                        // onClick={() => playsGEvent(item.permalink)}
                        /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_AppLink_AppLink__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                                href: _helpers__WEBPACK_IMPORTED_MODULE_6__/* .Permalink.play */ .xm.play(play, lang),
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
                                    tabIndex: -1,
                                    children: [
                                        play.state === _typings_api__WEBPACK_IMPORTED_MODULE_7__/* .PlayState.PROMOTED */ .QT.PROMOTED ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                            className: "coming-soon",
                                            children: t("coming_soon")
                                        }) : null,
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_DramoxImage__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                                            placeholderClass: "image-wrapper-for-playlist",
                                            src: play.poster_url,
                                            alt: play.title,
                                            width: 256,
                                            height: 144,
                                            quality: 90
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                                                    children: (0,_helpers__WEBPACK_IMPORTED_MODULE_6__/* .truncateTitle */ .ew)(play.title)
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                    children: play === null || play === void 0 ? void 0 : (ref = play.theatre) === null || ref === void 0 ? void 0 : ref.name
                                                })
                                            ]
                                        })
                                    ]
                                })
                            })
                        }, i);
                    })
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (CategorySectionPlaylist);


/***/ }),

/***/ 11965:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8014);
/* harmony import */ var context__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52662);
/* harmony import */ var helpers_jsx__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(28808);
/* harmony import */ var next_translate_useTranslation__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(62044);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(1984);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _components_CategorySections_CategorySectionPlaylist__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(2297);
/* harmony import */ var _components_Layout__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(46323);
/* harmony import */ var _enums_namespaces__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(99731);








var Playlist = function(param) {
    var plays = param.plays, countryCode = param.countryCode;
    var t = (0,next_translate_useTranslation__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_enums_namespaces__WEBPACK_IMPORTED_MODULE_7__/* .Namespace.Common */ .l.Common).t;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_Layout__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
        countryCode: countryCode,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_head__WEBPACK_IMPORTED_MODULE_4___default()), {
                children: (0,helpers_jsx__WEBPACK_IMPORTED_MODULE_2__/* .basicSEO */ .F)(t("seo:playlist_recent_title"), t("seo:playlist_recent_description"))
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_CategorySections_CategorySectionPlaylist__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                headline: t("common:playlist_recent_title"),
                plays: plays
            })
        ]
    });
};
var __N_SSP = true;
/* harmony default export */ __webpack_exports__["default"] = ((0,context__WEBPACK_IMPORTED_MODULE_1__/* .withForcePlanToLoggedInUnsubs */ .DE)(Playlist));


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,2888,179], function() { return __webpack_exec__(26908); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);